"use client";

import { Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Brandmarquee() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: marqueeRef,
    isVisible: marqueeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const allPartners = [{
    name: "Client A",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_a.png"
  }, {
    name: "Client B",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_b.png"
  }, {
    name: "Client C",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_c.png"
  }, {
    name: "Client D",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_d.png"
  }, {
    name: "Client E",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_e.png"
  }, {
    name: "Client F",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_f.png"
  }, {
    name: "Client G",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_g.png"
  }, {
    name: "Client H",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_h.png"
  }, {
    name: "Client I",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_i.png"
  }, {
    name: "Client J",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_j.png"
  }, {
    name: "Client K",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_k.png"
  }, {
    name: "Client L",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_l.png"
  }, {
    name: "Client M",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_m.png"
  }, {
    name: "Client N",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_n.png"
  }, {
    name: "Client O",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_o.png"
  }, {
    name: "Client P",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_p.png"
  }];
  const testimonials = [{
    quote: "Collaborare con Marinela ha trasformato radicalmente la nostra presenza digitale. Un approccio creativo e meticoloso.",
    name: "Giulia Rossi",
    role: "Direttrice Creativa",
    company: "Studio Design",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_a.png"
  }, {
    quote: "La visione strategica di Marinela è stata fondamentale per il lancio del nostro nuovo brand. Risultati oltre le aspettative.",
    name: "Marco Bianchi",
    role: "Fondatore",
    company: "Tech Innovators",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_b.png"
  }, {
    quote: "Un talento raro nel combinare estetica e funzionalità. Ogni progetto è curato nei minimi dettagli con grande professionalità.",
    name: "Elena Verdi",
    role: "Marketing Manager",
    company: "Luxury Retail",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/client_c.png"
  }];
  return <section data-section-id="879" id="brandmarquee" className="relative overflow-hidden bg-background py-24 text-foreground">
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative mx-auto max-w-7xl px-6">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center transition-all duration-700 ease-out ${headerVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          <p className="font-default text-xs uppercase tracking-widest text-primary">
            Collaborazioni di successo
          </p>
          <h2 className="font-default mt-5 text-4xl font-semibold leading-tight tracking-tight sm:text-6xl">
            <span style={{
            fontFamily: "var(--font-serif)"
          }}>
              Brand che hanno scelto{" "}
              <em className="text-primary not-italic">
                <span className="italic">Marinela</span>
              </em>
              .
            </span>
          </h2>
          <p className="mt-5 text-xl text-muted-foreground">
            Lavoro a stretto contatto con aziende visionarie per creare identità visive forti e strategie digitali d'impatto.
          </p>
        </div>

        

        <div ref={cardsRef} className={`mt-20 grid grid-cols-1 gap-6 transition-all duration-700 ease-out md:grid-cols-3 ${cardsVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
          {testimonials.map((t, i) => <Card key={i} data-index={i} className="relative rounded-lg border border-border bg-card shadow-md transition-colors hover:border-primary/40">
              <CardContent className="flex h-full flex-col gap-6 p-6">
                <div className="flex items-start justify-between">
                  <Quote className="h-5 w-5 text-primary" aria-hidden="true" />
                  <img src={t.logo} alt={t.company} loading="lazy" decoding="async" className="h-6 w-auto opacity-60" />
                </div>
                <p className="text-xl leading-relaxed text-foreground">
                  &ldquo;{t.quote}&rdquo;
                </p>
                <div className="mt-auto border-t border-border pt-4">
                  <p className="font-default text-sm font-semibold text-foreground">
                    {t.name}
                  </p>
                  <p className="font-default text-xs uppercase tracking-wider text-muted-foreground">
                    {t.role} &middot; {t.company}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>

      <style>{`
        @keyframes marquee-left {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.3333%); }
        }
        @keyframes marquee-right {
          0% { transform: translateX(-33.3333%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </section>;
}